
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full Name List of "Shri Swami Samarth" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full Name List of "Shri Swami Samarth" in both Marathi and English, with an option to switch between the two languages.'
           },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'swami samarth 108 names, shri swami samarth ashtottara namavali, shri swami samarth 108 namavali , 108 namavali swami samarth'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'swami samarth 108 names, shri swami samarth ashtottara namavali, shri swami samarth 108 namavali , 108 namavali swami samarth, स्वामी समर्थ १०८ नामावली, 108 names of Swami Samarth, Shri Swami Samarth Namavali in Sanskrit, Swami Samarth Namavali with meanings, Swami Samarth names chanting, Swami Samarth Namavali, 108 names of Shri Swami Samarth list'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/namavali/swami-samarth.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/namavali/swami-samarth.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Shri Swami Samarth Ashtottara Namavali | 108 Namavali - श्री स्वामी समर्थ अष्टोत्तरशत नामावली(108 नामावली)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/namavali/swami-samarth"
        },
        "headline": "Shri Swami Samarth Ashtottara Namavali - श्री स्वामी समर्थ अष्टोत्तरशत नामावली(108 नामावली)",
        "name" : "Shri Swami Samarth Ashtottara Namavali - 108 Namavali",
        "description": "Explore the full Name List of 'Shri Swami Samarth' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/namavali/swami-samarth.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  